import { useEffect, useState } from "react";
import Modal from "../modal/modal";

const Get_Vacancies = () => {
  const [vacancies, setVacancies] = useState([]);
  const [search, setSearch] = useState("");
  const [modalMessage, setModalMessage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchVacancies = (page = 1) => {
    setLoading(true);
    setError(null);

    fetch(`/api/get_Vacancies.php?page=${page}&limit=20`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log("API Response:", data);
        if (data.success) {
          setVacancies(data.vacancies || []);
          setTotalPages(data.totalPages || 1);
          setCurrentPage(page);
        } else {
          setError(data.message || "Unknown error");
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setError(err.message);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchVacancies(1);
  }, []);

  // Модалка для добавления в ТОП
  const confirmAddToTop = (id, workName) => {
    setModalMessage({
      id,
      title: "Ավելացնել ԹՈՓ-ում?",
      text: `Դուք ավելացնելու եք "${workName}"-ը ԹՈՓ աշխատատեղերի ցանկում`,
      actions: [
        {
          label: "Ավելացնել",
          success: true,
          onClick: () => handleAddToTop(id),
        },
        {
          label: "Չեղարկել",
          success: false,
          onClick: () => setModalMessage(null),
        },
      ],
    });
  };

  // Модалка для удаления из ТОП
  const confirmRemoveFromTop = (id, workName) => {
    setModalMessage({
      id,
      title: "Հեռացնել ԹՈՓ-ից?",
      text: `Դուք հեռացնելու եք "${workName}"-ը ԹՈՓ աշխատատեղերի ցանկից`,
      actions: [
        {
          label: "Հեռացնել",
          success: true,
          onClick: () => handleRemoveFromTop(id),
        },
        {
          label: "Չեղարկել",
          success: false,
          onClick: () => setModalMessage(null),
        },
      ],
    });
  };

  // Модалка для удаления вакансии
  const confirmDelete = (id, workName) => {
    setModalMessage({
      id,
      title: "Ցանկանում եք ջնջել այս աշխատատեղը?",
      text: `Դուք ջնջելու եք աշխատատեղը "${workName}"`,
      actions: [
        {
          label: "Ջնջել",
          success: true,
          onClick: () => handleDelete(id),
        },
        {
          label: "Չեղարկել",
          success: false,
          onClick: () => setModalMessage(null),
        },
      ],
    });
  };

  // Добавить в ТОП
  const handleAddToTop = (id) => {
    fetch(`/api/update_vacancy_top.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        is_top: 1,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setVacancies((prev) =>
            prev.map((v) => (v.id === id ? { ...v, is_top: 1 } : v))
          );
        } else {
          alert("Անհաջող ավելացում: " + data.message);
        }
      })
      .catch((err) => alert("Սխալ: " + err))
      .finally(() => setModalMessage(null));
  };

  // Удалить из ТОП
  const handleRemoveFromTop = (id) => {
    fetch(`/api/update_vacancy_top.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        is_top: 0,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setVacancies((prev) =>
            prev.map((v) => (v.id === id ? { ...v, is_top: 0 } : v))
          );
        } else {
          alert("Անհաջող հեռացում: " + data.message);
        }
      })
      .catch((err) => alert("Սխալ: " + err))
      .finally(() => setModalMessage(null));
  };

  const handleDelete = (id) => {
    fetch(`/api/delete_vacancy.php?id=${id}`)
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then((data) => {
        if (data.success) {
          setVacancies((prev) => prev.filter((v) => v.id !== id));
          fetchVacancies(currentPage);
        } else {
          alert("Անհաջող ջնջում: " + data.message);
        }
      })
      .catch((err) => {
        console.error("Delete error:", err);
        alert("Կապի սխալ: Սերվերը անհասանելի է");
      })
      .finally(() => setModalMessage(null));
  };

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleDateString("hy-AM");
  };

  const filtered = vacancies.filter((v) => {
    const s = search.toLowerCase();
    const id = (v.id ?? "").toString().toLowerCase();
    const workName = (v.workname ?? "").toLowerCase();
    const companyId = (v.companyId ?? "").toString().toLowerCase();
    const companyName = (v.companyName ?? "").toLowerCase();
    const createdDate = formatDate(v.created_at).toLowerCase();
    const deadline = formatDate(v.deadline).toLowerCase();

    return (
      id.includes(s) ||
      workName.includes(s) ||
      companyId.includes(s) ||
      companyName.includes(s) ||
      createdDate.includes(s) ||
      deadline.includes(s)
    );
  });

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      fetchVacancies(newPage);
    }
  };

  if (loading) {
    return (
      <section className="px-3 sm:px-4 md:px-6">
        <div className="flex justify-center items-center h-64">
          <div className="text-white text-lg sm:text-xl">Բեռնվում է...</div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="px-3 sm:px-4 md:px-6">
        <div className="flex justify-center items-center h-64">
          <div className="text-red-400 text-lg sm:text-xl">Սխալ: {error}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="px-3 sm:px-4 md:px-6">
      {modalMessage && (
        <Modal
          title={modalMessage.title}
          text={modalMessage.text}
          actions={modalMessage.actions}
        />
      )}

      {/* Заголовок и поиск */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">
          Աշխատատեղերի բազա
        </h1>

        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Որոնում..."
          className="w-full sm:w-72 px-4 py-2 rounded-lg bg-white/10 text-white placeholder-white/40 
                     border border-white/20 focus:outline-none focus:border-white 
                     transition text-sm sm:text-base"
        />
      </div>

      {/* Десктопная таблица */}
      <div className="hidden md:block overflow-x-auto rounded-lg border border-white/20 backdrop-blur-xl">
        <table className="min-w-full text-white border-collapse">
          <thead>
            <tr className="bg-white/10">
              <th className="py-3 px-4 border border-white/20 text-left">
                Աշխատատեղի ID
              </th>
              <th className="py-3 px-4 border border-white/20 text-left">
                Հաստիքի անուն
              </th>
              <th className="py-3 px-4 border border-white/20 text-left">
                ԹՈՓ
              </th>
              <th className="py-3 px-4 border border-white/20 text-left">
                Կազմակերպության ID
              </th>
              <th className="py-3 px-4 border border-white/20 text-left">
                Կազմակերպության անուն
              </th>
              <th className="py-3 px-4 border border-white/20 text-left">
                Տեղադրվել է
              </th>
              <th className="py-3 px-4 border border-white/20 text-left">
                Վերջնաժամկետ
              </th>
              <th className="py-3 px-4 border border-white/20 text-left">
                Գործողություններ
              </th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((v) => (
              <tr
                key={v.id}
                className="hover:bg-white/5 transition border border-white/10"
              >
                <td className="py-3 px-4 border border-white/10">{v.id}</td>
                <td className="py-3 px-4 border border-white/10">
                  {v.workname}
                </td>
                <td className="py-3 px-4 border border-white/10 text-center">
                  {v.is_top === 1 || v.is_top === true ? (
                    <div className="flex flex-col items-center space-y-1">
                      <span className="text-green-400 text-lg">✅</span>
                      <button
                        onClick={() => confirmRemoveFromTop(v.id, v.workname)}
                        className="text-xs text-red-300 hover:text-red-100 underline"
                      >
                        հեռացնել
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => confirmAddToTop(v.id, v.workname)}
                      className="px-2 py-1 bg-blue-600/50 hover:bg-blue-600 rounded-lg border border-blue-400/30 transition text-sm"
                    >
                      + ԹՈՓ
                    </button>
                  )}
                </td>
                <td className="py-3 px-4 border border-white/10">
                  {v.companyId || "—"}
                </td>
                <td className="py-3 px-4 border border-white/10">
                  {v.companyName}
                </td>
                <td className="py-3 px-4 border border-white/10">
                  {formatDate(v.created_at)}
                </td>
                <td className="py-3 px-4 border border-white/10">
                  {formatDate(v.deadline)}
                </td>
                <td className="py-3 px-4 border border-white/10">
                  <button
                    onClick={() => confirmDelete(v.id, v.workname)}
                    className="px-3 py-1 bg-red-600/50 hover:bg-red-600 rounded-lg border border-red-400/30 transition"
                  >
                    ջնջել
                  </button>
                </td>
              </tr>
            ))}

            {filtered.length === 0 && vacancies.length === 0 && (
              <tr>
                <td
                  colSpan="8"
                  className="py-4 px-4 text-center text-white/50 border border-white/20"
                >
                  Տվյալներ չկան
                </td>
              </tr>
            )}

            {filtered.length === 0 && vacancies.length > 0 && (
              <tr>
                <td
                  colSpan="8"
                  className="py-4 px-4 text-center text-white/50 border border-white/20"
                >
                  Ոչինչ չի գտնվել
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Мобильные карточки */}
      <div className="md:hidden space-y-3">
        {filtered.map((v) => (
          <div
            key={v.id}
            className="bg-white/5 rounded-lg border border-white/20 p-4 space-y-2"
          >
            <div className="flex justify-between items-start gap-2">
              <div>
                <span className="text-xs text-white/60">ID: {v.id}</span>
                {v.companyId && (
                  <span className="text-xs text-white/60 ml-2">Կազմ. ID: {v.companyId}</span>
                )}
              </div>
              <span className="text-xs text-white/60">{formatDate(v.created_at)}</span>
            </div>
            
            <h3 className="text-white font-medium text-sm sm:text-base break-words">
              {v.workname}
            </h3>
            
            <p className="text-white/70 text-xs sm:text-sm">
              {v.companyName}
            </p>
            
            <div className="flex justify-between items-center text-xs text-white/50">
              <span>Վերջնաժամկետ: {formatDate(v.deadline)}</span>
            </div>

            <div className="flex gap-2 pt-2">
              {v.is_top === 1 || v.is_top === true ? (
                <button
                  onClick={() => confirmRemoveFromTop(v.id, v.workname)}
                  className="flex-1 px-3 py-2 bg-green-600/30 hover:bg-green-600/50 rounded-lg border border-green-400/30 transition text-white text-sm"
                >
                  ✅ ԹՈՓ (հեռացնել)
                </button>
              ) : (
                <button
                  onClick={() => confirmAddToTop(v.id, v.workname)}
                  className="flex-1 px-3 py-2 bg-blue-600/30 hover:bg-blue-600/50 rounded-lg border border-blue-400/30 transition text-white text-sm"
                >
                  + ԹՈՓ
                </button>
              )}
              <button
                onClick={() => confirmDelete(v.id, v.workname)}
                className="flex-1 px-3 py-2 bg-red-600/50 hover:bg-red-600 rounded-lg border border-red-400/30 transition text-white text-sm"
              >
                ջնջել
              </button>
            </div>
          </div>
        ))}

        {filtered.length === 0 && vacancies.length === 0 && (
          <div className="text-center text-white/50 py-8 bg-white/5 rounded-lg border border-white/20">
            Տվյալներ չկան
          </div>
        )}

        {filtered.length === 0 && vacancies.length > 0 && (
          <div className="text-center text-white/50 py-8 bg-white/5 rounded-lg border border-white/20">
            Ոչինչ չի գտնվել
          </div>
        )}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center items-center mt-4 sm:mt-6 gap-2 sm:space-x-4">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-3 sm:px-4 py-1.5 sm:py-2 bg-white/10 hover:bg-white/20 rounded-lg border border-white/20 
                       disabled:opacity-50 disabled:cursor-not-allowed transition text-sm sm:text-base"
          >
            Նախորդ
          </button>

          <span className="text-white text-sm sm:text-base">
            Էջ {currentPage} / {totalPages}
          </span>

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-3 sm:px-4 py-1.5 sm:py-2 bg-white/10 hover:bg-white/20 rounded-lg border border-white/20 
                       disabled:opacity-50 disabled:cursor-not-allowed transition text-sm sm:text-base"
          >
            Հաջորդ
          </button>
        </div>
      )}
    </section>
  );
};

export default Get_Vacancies;